import { createRouter, createWebHistory } from "vue-router";

import { fetchUserData } from "@/services/account";
import routes from "./routes";
import posthog from 'posthog-js'

const router = createRouter({
    history: createWebHistory(),
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        } else {
            return { top: 0 };
        }
    }
});

router.beforeEach(async (to, from, next) => {
    document.title = `Tripcart - ${to.meta.title}`;
    const APP_URL = import.meta.env.VITE_APP_URL;
    const currentURL = window.location.host;
    const APP_URL_STRIPPED = APP_URL.replace(/^(https?:\/\/)/, '');
    if (to.name == 'NotFound') {
        window.location.href = APP_URL_STRIPPED == currentURL ? '/login' : '/not-found'
    } else {
        if (to.meta.middleware) {
            for (const middleware of to.meta.middleware) {
                await middleware(to, from, next);
            }
        }
        /**
         * Check if user is subscribed / trial remaining days
         * If not subscribed, redirect to plans page
         * If subscribed, redirect to dashboard
         */
        if (to.name == 'team-management-create') {
            let plansAndUsages = localStorage.getItem('plansAndUsages');
            plansAndUsages = plansAndUsages ? JSON.parse(plansAndUsages) : {};
            if (plansAndUsages) {
                switch (to.name.trim()) {
                    case 'team-management-create':
                        plansAndUsages.team_used_percentage >= 100 ? next({ name: "team-management" }) : next();
                        break;
                    default:
                        break;
                }
            }
        }
        await checkSubscription(to) ? next() : next({ name: "plans" });
    }
});
// Automatically track page views
router.afterEach((to) => {
    posthog.capture('$pageview', { current_url: to.fullPath })
})

async function checkSubscription(to) {
    const trialRemainingDays = JSON.parse(localStorage.getItem("trialRemainingDays"));
    const isSubscribed = JSON.parse(localStorage.getItem("isSubscribed"));
    const excludedRoutes = [
        "agency-info",
        "website-info",
        "agency-address",
        "my-agencies",
        "login",
        "plans",
        "register",
        "verify-email",
        "forget-password",
        "password-notification"
    ];
    if (!trialRemainingDays && !isSubscribed && !excludedRoutes.includes(to.name.trim())) {
        if (trialRemainingDays == null && isSubscribed == null) {
            const response = await fetchUserData();
            if (response.data.data) {
                localStorage.setItem("trialRemainingDays", response.data.data.trial_remaining_days);
                localStorage.setItem("isSubscribed", response.data.data.is_subscribed);
                return true;
            }
        }
        return false;
    }
    return true;
}

export default router;
